import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { addNewHorizontalLayout, addNewVerticalLayout } from '../../data/dashboardsSlice';
import { get_guid } from '../../helpers/misc';
import { TpDashboardContext } from '../interfaces';

export function promptAddHorizontalLayout(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentId: string,
  dispatch: AppDispatch,
) {
  dispatch(
    addNewHorizontalLayout({ dashboardDefId: dashboardContext.dashboardDefId, parentId, id: get_guid(), height: 0 }),
  );
}

export function promptAddVerticalLayout(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentId: string,
  dispatch: AppDispatch,
) {
  dispatch(
    addNewVerticalLayout({ dashboardDefId: dashboardContext.dashboardDefId, parentId, id: get_guid(), height: 0 }),
  );
}
